import React from "react";

import Tetris from "./Tetris";
import { useGameOver } from "../hooks/useGameOver";
import { GameProvider } from "../context/GameContext";

const Game: React.FC = () => {
  const [gameOver, setGameOver, isGameLobby, setIsGameLobby] = useGameOver();

  return (
    <>
      <GameProvider
        value={{
          gameOver,
          setGameOver,
          isGameLobby,
          setIsGameLobby,
        }}
      >
        <Tetris rows={20} columns={10} />
      </GameProvider>
    </>
  );
};

export default Game;
